export default class ServiceType {}

ServiceType.Allergies = 'ALLERGIES';
ServiceType.FleaAndTick = 'FLEA_AND_TICK';
